import { render, staticRenderFns } from "./SeguimientoGuia.vue?vue&type=template&id=79c06042&scoped=true"
import script from "./SeguimientoGuia.vue?vue&type=script&lang=js"
export * from "./SeguimientoGuia.vue?vue&type=script&lang=js"
import style0 from "./SeguimientoGuia.vue?vue&type=style&index=0&id=79c06042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c06042",
  null
  
)

export default component.exports